import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { removeEmptyKeys } from "@Shared/utils/utils";
import { putAccountsApi, getSecureAccountsApi, postSecureAccountsApi, postMainApi, putMainApi, deleteMainApi, deleteAccountsApi, getMainApi, getDocumentsApi } from "@Shared/utils/ajax";
import { isUndefined, omitBy } from "lodash";
import { parseParams } from "@Shared/@Utils/constants";
// import NewSchema from "@Shared/@DataFiles/new-schema.json";

/**
 * Mark application as complete with given status
 * @param status one of the allowed completed status
 * @param clientUsername
 * @param applicationId
 */
export const completeApplication = async (status, clientUsername, applicationId) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/complete`;
  return postMainApi({
    status
  }, endpoint);
};
/**
 * Get client application data
 */
export const getApplicationData = async (clientUsername, applicationId, agentUsername, clientProfileId) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}`;
  return getMainApi(omitBy({
    agentUsername: agentUsername,
    clientProfileId
  }, isUndefined), endpoint);
};
export const submitInsuranceRequest = async (clientUsername, applicationId, data) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/insurance`;
  return postMainApi(data, endpoint);
};
export const getInsuranceSubmissionsHistory = async (applicationId, clientUsername) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/insurance-submission`;
  return getMainApi({}, endpoint);
};
export const getInsuranceProviders = () => {
  const endpoint = `/providers`;
  return getMainApi({}, endpoint);
};
export const getClientData = async (clientUsername, agentUsername, clientProfileId, applicationId) => {
  return getMainApi(omitBy({
    agentUsername,
    clientProfileId,
    applicationId
  }, isUndefined), `/client/${clientUsername}`);
};

/**
 * Send request to update application
 */
export const updateApplication = async (application, applicationId, clientUsername, compute) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}${compute ? "?compute=true" : ""}`;
  delete application.saving;
  return putMainApi({
    application: removeEmptyKeys(application)
  }, endpoint);
};
export const getCalculationsData = async (applicationId, clientUsername) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/calculators`;
  return getMainApi({}, endpoint);
};
export const getCalculatedValues = async (applicationId, clientUsername) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/calculators?all=true`;
  return getMainApi({}, endpoint);
};

/**
 * Request to get all documents for a client
 */
export const getClientRequestEmail = async (applicationId, clientUsername) => {
  const endpoint = `/application/${applicationId}/client-request/${clientUsername}/email`;
  return getDocumentsApi({}, endpoint);
};
export const shareApplication = async (applicationId, clientUsername, emailToSend) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/share`;
  return postMainApi({
    emailToSend
  }, endpoint);
};
export const createRequestPackage = async (applicationId, clientUsername, data) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/request-data`;
  const payload = {
    requests: [data],
    type: "consolidated"
  };
  return postMainApi(payload, endpoint);
};
export const toggleApplicationLock = async (applicationId, clientUsername) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/lock`;
  return postMainApi({}, endpoint);
};

/**
 * Call to get bank statements information and email to send
 */
export const getBankStatements = async (applicationId, clientUsername) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/bank-statements`;
  return getMainApi({}, endpoint);
};

/**
 * Call to get requested data?
 */
export const getUserDataRequest = async (applicationId, clientUsername, type) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/request-data`;
  return getMainApi({
    type
  }, endpoint);
};

/**
 * Call to send bank statement requests
 */
export const sendUserDataRequest = async (applicationId, clientUsername, type, data) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/request-data`;
  return postMainApi({
    requests: [data],
    type
  }, endpoint);
};

/**
 *  Call to update client application request
 */
export const putUserDataRequest = async (applicationId, clientUsername, clientApplicationRequestId, data) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/request-data/${clientApplicationRequestId}`;
  return putMainApi(data, endpoint);
};

/**
 * Call to delete client application request
 */
export const deleteUserDataRequest = async (applicationId, clientUsername, clientApplicationRequestId) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/request-data/${clientApplicationRequestId}`;
  return deleteMainApi(endpoint);
};
export const sendClientRequestReminder = async (applicationId, clientUsername, clientApplicationRequestId) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/request-data/${clientApplicationRequestId}/remind`;
  return postMainApi({}, endpoint);
};

/** Call to fetch full social insurance number
 * @param refId the SIN ref to fetch
 */
export const getFullSIN = async (applicationId, clientUsername, refId) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/secure-data/${refId}`;
  return getMainApi({}, endpoint);
};
export const getSchema = async (isBrokerage = false) => {
  // return getLocal("new-schema");
  if (isBrokerage) return getMainApi({}, "/brokerage/customize/application");
  return getSecureAccountsApi({}, "/customize/application");
};
export const getCustomizationSchema = async () => {
  return getSecureAccountsApi({
    newApplication: true
  }, "/customize/application");
};
export const getCustomizationBrokerageSchema = async () => {
  return getMainApi({
    newApplication: true
  }, "/brokerage/customize/application");
};
export const updateSchema = async (isBrokerage, schema) => {
  delete schema.saving;
  delete schema.translationMap;
  if (isBrokerage) {
    return putMainApi(schema, "/brokerage/customize/application");
  }
  return putAccountsApi(schema, "/customize/application");
};
export const updateCustomizationBrokerageSchema = async schema => {
  return putMainApi(schema, "/brokerage/customize/application?newApplication=true");
};
export const resetCustomizationBrokerageSchema = async () => {
  return putMainApi({}, "/brokerage/customize/application?newApplication=true&reset=true");
};
export const updateCustomizationSchema = async schema => {
  return putAccountsApi(schema, "/customize/application?newApplication=true");
};
export const resetCustomizationSchema = async () => {
  return putAccountsApi({}, "/customize/application?newApplication=true&reset=true");
};
export const updateDisclaimers = async (isBrokerage, disclaimers) => {
  if (isBrokerage) {
    return putMainApi({
      disclaimers
    }, "/brokerage/customize/disclaimer");
  }
  return putAccountsApi({
    disclaimers
  }, "/customize/disclaimer");
};
export const markApplicationAsRead = async clientUsername => {
  const endpoint = `/client/${clientUsername}/application/read`;
  return postMainApi({}, endpoint);
};

/**
 * Request to get all documents for a client
 */
export const getDocumentClassifications = async (applicationId, clientUsername) => {
  const endpoint = `/application/${applicationId}`;
  return getDocumentsApi({
    client: clientUsername
  }, endpoint);
};
export const submitToFilogix = async (applicationId, clientUsername, filogixPassword) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/filogix`;
  return postMainApi({
    filogixPassword
  }, endpoint);
};
export const getFilogixDeals = async (applicationId, clientUsername) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/filogix`;
  return getMainApi({}, endpoint);
};
export const updateFilogixDeal = async (applicationId, clientUsername, filogixSubmissionId, details) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/filogix/${filogixSubmissionId}`;
  return putMainApi(details, endpoint);
};
export const updateFilogixDealStatus = async (applicationId, clientUsername, status) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/filogix/status`;
  return putMainApi({
    status
  }, endpoint);
};
export const submitFilogixDeal = async (applicationId, clientUsername, filogixPassword) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/filogix`;
  return postMainApi({
    filogixPassword
  }, endpoint);
};
export const syncFilogixDealApplication = async (applicationId, clientUsername, filogixSubmissionId) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/filogix/${filogixSubmissionId}/sync`;
  return putMainApi({}, endpoint);
};
export const createEsignTemplate = async templateData => {
  const endpoint = "/customize/e-sign/template";
  return postSecureAccountsApi(templateData, endpoint);
};
export const editESignTemplate = async templateId => {
  const endpoint = `/customize/e-sign/template/${templateId}`;
  return getSecureAccountsApi({}, endpoint);
};
export const markEsignTemplateAsComplete = async templateId => {
  const endpoint = `/customize/e-sign/template/${templateId}`;
  return postSecureAccountsApi({}, endpoint);
};
export const getEsignTemplates = async () => {
  const endpoint = "/customize/e-sign/template";
  return getSecureAccountsApi({
    shared: true
  }, endpoint);
};
export const deleteEsignTemplate = async templateId => {
  const endpoint = `/customize/e-sign/template/${templateId}`;
  return deleteAccountsApi(endpoint);
};
export const deleteApplication = async (clientUsername, applicationId) => {
  return deleteMainApi(`/client/${clientUsername}/application/${applicationId}`);
};
export const getMutedAutomations = async (clientUsername, applicationId) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/mute`;
  return getMainApi({}, endpoint);
};
export const updateMutedAutomations = async (clientUsername, applicationId, mutedAutomations) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/mute`;
  return putMainApi(mutedAutomations, endpoint);
};
export const swapApplicants = async (clientUsername, applicationId, coApplicantIndex) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/switch`;
  return postMainApi({
    coApplicantIndex
  }, endpoint);
};
export const previewRequestPackage = async (applicationId, clientUsername, data) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/request-data/preview`;
  const payload = _objectSpread(_objectSpread({}, data), {}, {
    type: "consolidated"
  });
  return postMainApi(payload, endpoint);
};
export const syncSubmissionAgentFromExpert = async () => {
  return getMainApi({}, "/filogix/import/submission-agent");
};
export const getApplicationSyncStatus = async ({
  applicationId,
  clientUsername,
  latest = false,
  offset = 0,
  limit = 10,
  eventType = ""
}) => {
  const params = parseParams({
    latest,
    offset,
    limit,
    eventType
  });
  const endpoint = `/client/${clientUsername}/application/${applicationId}/erd/sync-history${params}`;
  return getMainApi({}, endpoint);
};
export const retryApplicationSync = (applicationId, clientUsername) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/erd/sync`;
  return postMainApi({}, endpoint);
};
export const syncApplicationToClientProfile = (applicationId, clientUsername, clientProfileId) => {
  const endpoint = `/client/${clientUsername}/application/${applicationId}/synchronize`;
  return postMainApi({
    clientProfileId
  }, endpoint);
};
export const searchParticipants = (ownFirmOnly, firstName, lastName) => {
  const endpoint = `/filogix/search/user`;
  return getMainApi({
    ownFirmOnly,
    firstName,
    lastName
  }, endpoint);
};
export const autoComposeEmail = async (clientProfile, settings) => {
  const generatedEmail = await postMainApi({
    clientProfile,
    settings
  }, `/auto-compose-email/generate`);
  return {
    generatedEmail: generatedEmail.emailModel.content,
    subject: generatedEmail.emailModel.subject,
    isError: generatedEmail.isError,
    clientProfileId: generatedEmail.clientProfileId
  };
};
export const saveEmailPrompt = async (title, prompt) => {
  const endpoint = `/auto-compose-email/save-prompt`;
  return postMainApi({
    title,
    prompt
  }, endpoint);
};
export const getSavedEmailPrompts = async () => {
  const endpoint = `/auto-compose-email/load-prompts`;
  return getMainApi({}, endpoint);
};
export const updateEmailPrompt = async (promptId, title, prompt) => {
  const endpoint = `/auto-compose-email/prompt/${promptId}`;
  return putMainApi({
    title,
    prompt
  }, endpoint);
};
export const deleteEmailPrompt = async promptId => {
  const endpoint = `/auto-compose-email/prompt/${promptId}`;
  return deleteMainApi(endpoint);
};